export const ACCOUNT_LINKED_UPDATE = 'ACCOUNT_LINKED_UPDATE';

export const ACCOUNT_STATUS = {
  OPEN: 'open',
  FROZEN: 'frozen',
  CLOSED: 'closed'
};
